(() => {
  const destinations = {
    'apparel & shoes': '/collections/clothing?view=apparel-collections',
    'home & lifestyle': '/collections/accessories-towels-towel-rug-rugs-bag-tote?view=home-capsule-collections',
    'mugs & drinkware': '/collections/mugs-tumblers',
    'bags & accessories': '/collections/backpacks-bags'
  };

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function connectHeader(root = document) {
    root.querySelectorAll('header a.nav-link, header .side-menu a.list-menu__item').forEach((link) => {
      const firstText = link.childNodes[0] ? link.childNodes[0].textContent : '';
      const destination = destinations[normalize(firstText)] || destinations[normalize(link.textContent)];
      if (!destination) return;
      link.setAttribute('href', destination);
      link.dataset.oldSoulLanding = 'true';
    });
  }

  function loadBrandDestinations(root = document) {
    if (!root.querySelector || !root.querySelector('.osv8-brand-card')) return;
    if (window.OldSoulBrandDestinationsLoaded || document.querySelector('script[data-old-soul-brand-destinations]')) return;
    const script = document.createElement('script');
    script.src = "{{ 'old-soul-brand-destinations.js' | asset_url }}";
    script.async = true;
    script.dataset.oldSoulBrandDestinations = 'true';
    document.head.appendChild(script);
  }

  function init(root = document) {
    connectHeader(root);
    loadBrandDestinations(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
